
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoxDimensions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Box"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":47}};
    doc.loc.source = {"body":"fragment BoxDimensions on Box {\n  dimensions\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    



//////////////////
// WEBPACK FOOTER
// ./src/graphql/BoxDimensionsFragment.graphql
// module id = 7Ybn
// module chunks = 1